import { Injectable } from '@angular/core';
import { CFHttpClient } from '../shared/cf-http-client';
import { UserSession } from '../shared/user-session';
import {environment} from '../../environments/environment';

const emailConfirmUrl = environment.servicePublicURLs.emailConfirmURL; //'/mas/pub/confirmEmailAddressEncrypted.json';
const consentUpdateUrl = environment.servicePublicURLs.consentUpdateURL; //'/mas/pub/updateMemberConsent.json';

@Injectable()
export class WelcomeEmailService {
    emailID: string = '';
    consentUpdated: string = '';
    consentSkip: string = '';

    constructor(
        private http: CFHttpClient,
        private userSession: UserSession
    ) { }

    welcomeEmailVerification(mKey: any, activationCode: any) {

        let inputParams = {
            "mKey": mKey,
            "activationCode": activationCode
        }
        this.userSession.setCurrentAccountId("");
        return this.http.get(emailConfirmUrl, inputParams)
    }

    consentUpdate(mKey : any) {
        let inputParams = {
            "mKey": mKey
        }
        return this.http.get(consentUpdateUrl, inputParams);
    }

}



// WEBPACK FOOTER //
// ./src/app/welcome-email/welcome-email.service.ts